import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { bindActionCreatorsSafe } from 'util/safeDispatch';
import { Field, reduxForm, type FormProps } from 'redux-form';
import { type Dispatch } from 'state/types';

import localizedStrings from 'util/localizedStrings';
import { getGlobalSettings } from 'state/selectors';
import LabeledField from 'view/Forms/LabeledField';
import { GLOBAL_SETTING } from 'util/serverUtils';
import { setSingleSignOnCredentials } from 'state/commands/ssoCommands';

type Props = {
  globalSettings: GlobalSettings,
  setSingleSignOnCredentials: typeof setSingleSignOnCredentials,
} & FormProps;

class SingleSignOnCredsPage extends Component<Props, State> {
  submit: Function;

  constructor() {
    super();
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    const { setSingleSignOnCredentials } = this.props;
    const { username, password } = values;
    setSingleSignOnCredentials(username, password);
  }

  render() {
    const {
      handleSubmit,
      intl: { formatMessage },
      invalid,
      pristine,
      reset,
    } = this.props;

    return (
      <div className="page page-contents" data-test-name="sso-credentials-page">
        <header className="page-header">
          <FormattedMessage
            {...localizedStrings.GLOBAL_SETTINGS_SSO_CREDENTIALS}
          />
        </header>

        <div className="section page-contents-textured portfolio-form-container">
          <div className="box">
            <form
              onSubmit={handleSubmit(this.submit)}
              style={{ width: '600px' }}
            >
              <LabeledField
                labelClassName="is-medium"
                label={formatMessage(localizedStrings.USER_ACCOUNT)}
              >
                <Field
                  autoComplete="new-password"
                  className="input is-medium"
                  component="input"
                  id="username"
                  name="username"
                  type="string"
                  data-test-name="sso-credential"
                />
              </LabeledField>

              <LabeledField
                labelClassName="is-medium"
                label={formatMessage(localizedStrings.PASSWORD)}
              >
                <Field
                  autoComplete="new-password"
                  className="input is-medium"
                  component="input"
                  id="password"
                  name="password"
                  type="password"
                  data-test-name="sso-password"
                />
              </LabeledField>

              <div className="vertical-spacer-large" />

              <div className="field is-grouped is-pulled-right">
                <div className="control">
                  <button
                    className="button is-dark is-outlined"
                    disabled={pristine}
                    onClick={reset}
                    type="button"
                    data-test-name="sso-revert"
                  >
                    <FormattedMessage {...localizedStrings.REVERT} />
                  </button>
                </div>
                <div className="control">
                  <button
                    className={'button is-primary'}
                    type="submit"
                    disabled={pristine || invalid}
                    data-test-name="sso-apply"
                  >
                    <FormattedMessage {...localizedStrings.APPLY} />
                  </button>
                </div>
              </div>
              <div className="vertical-spacer-xlarge" />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function validate(data: Object, props: Props) {
  const errors = {};

  if (!data.username) {
    errors.username = 'Required';
  }
  if (!data.password) {
    errors.password = 'Required';
  }

  return errors;
}

const ssoCredentialsForm = reduxForm({
  form: 'Single Sign On Credentials Form',
  validate,
})(injectIntl(SingleSignOnCredsPage));

export default connect(
  state => ({
    globalSettings: getGlobalSettings(state),
    initialValues: {
      username: getGlobalSettings(state)[GLOBAL_SETTING.SSO_PRINCIPAL],
    },
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      getGlobalSettings,
      setSingleSignOnCredentials,
    })
)(ssoCredentialsForm);



// WEBPACK FOOTER //
// ./src/view/Pages/GlobalSettingsPages/SingleSignOnCredsPage.js